/*
 lib dependencies
 - throttle
*/
var lmnInView = (function($)
{
    const   _instances = [],
            _throttle = 100;
    let     _running = false,
            _visibleTop = false,
            _visibleBottom = false;

    function register(p)
    {
        p = $.extend({
    		el: false,
    		trigger: 'partially', //partially | completely
            report: 'change', //change | always
    		offset: 0,
            in: false,
            out: false
    	}, p);

        p.id = _instances.length;
        p.inReported = false;
        p.outReported = false;

        _instances.push(p);

        start();
    }

    function start()
    {
        if (!_running)
        {
            window.addEventListener('scroll', _handle);
            _running = true;
        }
    }

    const _handle = throttle(function(e)
    {
        _setVisibleArea();

        _instances.forEach(function(inst)
        {
            //element in view?
            const inView = (inst.trigger == 'partially') ? partiallyInView(inst.el, inst.offset, true) : completelyInView(inst.el, inst.offset, true);

            if (inView && inst.in)
            {
                if (inst.report == 'always') inst.in(inst.el);
                else if (!inst.inReported)
                {
                    inst.in(inst.el);

                    inst.inReported = true;
                    inst.outReported = false;
                }
            }
            else if (inst.out)
            {
                if (inst.report == 'always') inst.out(inst.el);
                else if (!inst.outReported)
                {
                    inst.out(inst.el);

                    inst.outReported = true;
                    inst.inReported = false;
                }
            }
        });
    }, _throttle);

    function completelyInView(el, offset=0, invokedByHandle=false)
    {
        if (!invokedByHandle) _setVisibleArea();

        const elBounds = _getElementBounds(el);

        return (_visibleBottom >= (elBounds.bottom + offset) && _visibleTop <= (elBounds.top + offset));
    }

    function partiallyInView(el, offset=0, invokedByHandle=false)
    {
        if (!invokedByHandle) _setVisibleArea();

        const elBounds = _getElementBounds(el);

        return !(_visibleBottom < (elBounds.top + offset) || _visibleTop > (elBounds.bottom + offset));
    }

    function _setVisibleArea()
    {
        _visibleTop = document.body.scrollTop;
        _visibleBottom = _visibleTop + window.innerHeight;
    }

    function _getElementBounds(el)
    {
        const elBounds = el.getBoundingClientRect();
        return { top: elBounds.top + _visibleTop, bottom: elBounds.bottom + _visibleTop };
    }

    //reveal public vars and functions
    return {
        //vars

        //functions
        register,
        start,
        completelyInView,
        partiallyInView
    };

})(jQuery);
